module.exports = __webpack_public_path__ + "static/emoji-ad34b5a7308164413d6dbd7cf44004ce.mp4";